var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgWifiAntenna = function SvgWifiAntenna(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 27"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wifi-antenna_svg__a)",
    filter: "url(#wifi-antenna_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6EB171",
    fillRule: "evenodd",
    d: "M20.508 4.48a1 1 0 1 0-1.146 1.64 6.3 6.3 0 0 1 1.93 2.17 5.78 5.78 0 0 1-.005 5.56 6.3 6.3 0 0 1-1.935 2.166 1 1 0 0 0 1.142 1.64 8.25 8.25 0 0 0 2.553-2.858 7.78 7.78 0 0 0 .005-7.456 8.3 8.3 0 0 0-2.544-2.862m-2.59 2.032a1 1 0 0 0-1.145 1.64c.48.336.877.78 1.157 1.292a3.35 3.35 0 0 1 0 3.278c-.28.516-.677.96-1.157 1.296a1 1 0 0 0 1.145 1.64 5.8 5.8 0 0 0 1.77-1.98 5.35 5.35 0 0 0-.002-5.19 5.8 5.8 0 0 0-1.768-1.976m-9.28-.324a1 1 0 1 0-1.146-1.64 8.3 8.3 0 0 0-2.53 2.83A7.68 7.68 0 0 0 4.95 14.8a8.3 8.3 0 0 0 2.552 2.86 1 1 0 0 0 1.142-1.642 6.3 6.3 0 0 1-1.936-2.168 5.69 5.69 0 0 1 .01-5.516A6.3 6.3 0 0 1 8.636 6.19zm2.588 1.964a1 1 0 1 0-1.145-1.64 5.8 5.8 0 0 0-1.773 1.986 5.35 5.35 0 0 0 .008 5.19 5.76 5.76 0 0 0 1.765 1.97 1 1 0 1 0 1.145-1.64 3.8 3.8 0 0 1-1.155-1.288 3.35 3.35 0 0 1-.005-3.278 3.8 3.8 0 0 1 1.16-1.3m2.743.104a2.812 2.812 0 0 0-1.25 5.332v8.162a1.25 1.25 0 0 0 2.5 0v-8.16a2.812 2.812 0 0 0-1.25-5.334",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wifi-antenna_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 3h20v20H4z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "wifi-antenna_svg__b",
    width: 28,
    height: 28,
    x: 0,
    y: -1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.431373 0 0 0 0 0.694118 0 0 0 0 0.443137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12610_11170"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_12610_11170",
    result: "shape"
  }))))));
};
export default SvgWifiAntenna;